$(document).ready(function(){

  $('body').on("click",".var_img",function(){
    
    var $this = $(this);
    $this.parent().parent().find(".var_img").removeClass('active');
    $this.addClass('active');
   	var main_obj = $this.parent().parent().parent().parent().parent();
    //console.log("Parent object "+main_obj.attr('class'));
    var roll_info = $this.parent().parent();
    var roll_data_obj = roll_info.children('.roll_info_'+$this.attr('data-color'));
    console.log("data "+roll_data_obj.attr('class'))
    
    /**Image change*/
    
    var image_change = main_obj.children('.product-card__image-with-placeholder-wrapper').children('.grid-view-item__image-wrapper').children('.product-list-image').children('.grid-view-item__image');
    image_change.attr('srcset',$this.attr('data-img'));
    image_change.attr('data-src',$this.attr('data-img'));
    
    var implement_control_obj = main_obj.parent().children('.controle_container');
    implement_control_obj.children('.buy_sample').children('.buy_sample_action').attr('data-id',$this.attr('data-id'));
    implement_control_obj.children('.view_sample').children('.quickview').attr('data-id',roll_data_obj.attr('data-id'));
  });
  
  setTimeout(function(){ 
  
  $(".active_search_color").each(function() {
    
    var $own = $(this);
    $own.parent().find('.var_img').removeClass('active');
    var $this = $own.children('.var_img');
    $this.addClass('active');
    
    var main_obj = $this.parent().parent().parent().parent().parent();
    //console.log("Parent object "+main_obj.attr('class'));
    
    var roll_info = $this.parent().parent();
    var roll_data_obj = roll_info.children('.roll_info_'+$this.attr('data-color'));
    console.log("data "+roll_data_obj.attr('class'))
    
    
    /**Image change*/
    
    var image_change = main_obj.children('.product-card__image-with-placeholder-wrapper').children('.grid-view-item__image-wrapper').children('.product-list-image').children('.grid-view-item__image');
    //console.log("Image  "+image_change.attr('id'));
    image_change.attr('srcset',$this.attr('data-img'));
    image_change.attr('data-src',$this.attr('data-img'));
    
    
    var implement_control_obj = main_obj.parent().children('.controle_container');
    //console.log("action "+implement_control_obj.attr('class'))
    implement_control_obj.children('.buy_sample').children('.buy_sample_action').attr('data-id',$this.attr('data-id'));
   
    //implement_control_obj.children('.view_sample').children('.quickview').attr('data-id',$this.attr('data-id'));
    implement_control_obj.children('.view_sample').children('.quickview').attr('data-id',roll_data_obj.attr('data-id'));
    
   	
   });
  
  
  
  }, 1000);
  
  
  $('body').on("click",".buy_sample_action",function(){
    var $this = $(this);
     //window.open('https://dado-ateleir-online.myshopify.com/cart/'+$(this).attr('data-id')+":1");
    $this.addClass('cart-loading');
    data = {
            id: $(this).attr('data-id'),
            quantity: 1
     },
       
     $.ajax({
          type: "POST",
          url: "/cart/add.js",
          data: data,
          dataType: "json",
          success: function(response) {
            setCart();
            
            setTimeout(function(){  
            
              
              //alert("count "+total_cart)
               /***Popup show ***/
              var html_cart_imagee='<img class="cart-popup-item__image" src="'+response.image+'" alt="">';
              var total_cart = $("#cart_count_input").val()
              $("#cart-notification-button").css({'display':'block'});
              $("#cart-notification-button").text('View my cart ('+total_cart+')');

              //$(".cart-popup-wrapper").html(html_cart);

              $(".cart-popup-wrapper").removeClass('cart-popup-wrapper--hidden');
              
              $(".cart-popup-item__image-wrapper").removeClass('hide');
              $(".cart-popup-item__image-wrapper").html(html_cart_imagee);
              $(".cart-popup-item__title").text(response.product_title);
              
              var html_types = "";
              var items_type = [];
              $.each(response.options_with_values,function(i,curval){
                items_type.push(curval.value);
              });
              let items_info = items_type.join();
              html_types='<li class="product-details__item product-details__item--variant-option">'+items_info+'</li>';
              $(".product-details").html(html_types);
              
              $(".cart-popup-item__quantity").children().last('span').text(1);
              
              var total_cart = $("#CartCount").attr('data-count');
              var total_subtotal = $("#CartCount").attr('data-subtotal');
              $(".cart-popup__cta-link").html('View cart (<span>'+total_cart+'</span>)');
              //$("#popup_cart_subtotal").text(total_subtotal);
              
              var popcartprice = parseFloat(response.price)/100;
              //$("#qty_price").text( popcartprice);
              $("#qty_price").html("<span class=money>&#163;"+popcartprice+"</span>");
              $("#popup_cart_subtotal").html("<span class=money>&#163;"+total_subtotal+"</span>")
              $("#qty_number").text(1);
              /***End Popup show ***/
              }, 500);
            
            
            
            $this.removeClass('cart-loading');
            //$this.text('Check out');
            //$this.addClass('checkout_product_cst');
            $this.removeClass('add_to_cart_ajax_cust_info');
            //$this.next('.cart_view').show();
            
            //mlvedaload();
            
          },error(response, status, error){
            $this.removeClass('cart-loading');
            if(response.responseJSON.status == "422"){
              alert("Can't add more same product in your cart - "+response.responseJSON.description);
            }else{
              alert("Sorry, Something went wrong, Please try after some time.");
            }
            
          
          }
        
        }); 
  		
  });
  
  $("body").on("click",".cart-popup__close",function(){
  
    $(".cart-popup-wrapper").addClass('cart-popup-wrapper--hidden');
    
  });
  
  function setCart(){
    var carttext  = 0;
    $.getJSON('/cart.js', function (cart, textStatus) {
      carttext=cart.item_count;
      $("#CartCount").children('span').text(carttext);
      $("#CartCount").attr('data-count',carttext);
      var price_total = parseFloat(cart.total_price)/100;
       $("#CartCount").attr('data-subtotal',price_total);
    });
    return carttext;
  }
  
  
  $(function(){
  
    
    $('.popper').hover(function() {
      var $this = $(this);
        $this.children('.pop').toggle();
    });
  
  });
  
  $("body").on("click",".grid-view-item__image",function(){
  		var product_link = $(this).attr('data-link');
    	window.location.href= product_link;
  })
  
  $('.collection-slider-home').slick({
  slidesToShow: 3,
  slidesToScroll: 3,
  autoplay: true,
  
  responsive: [
        {
          breakpoint: 991,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 3,
          },
        },
        {
          breakpoint: 575,
          settings: {
            slidesToShow:2,
            slidesToScroll: 2,
          
          },
        },
      ],
});
  
  $('.featured_container_right').slick({
  slidesToShow: 3,
  slidesToScroll: 3,
  autoplay: true,
  autoplaySpeed: 5000,
  
  responsive: [
    
        {
          breakpoint: 1463,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 2,
          },
        },
        {
          breakpoint: 1020,
          settings: {
            slidesToShow:1,
            slidesToScroll: 1,
          
          },
        },
      ],
});
  
    
  $('.blog-slider').slick({
  slidesToShow: 3,
  slidesToScroll: 3,
  autoplay: true,
  autoplaySpeed: 5000,
  
  responsive: [
        {
          breakpoint: 991,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 2,
          },
        },
        {
          breakpoint: 575,
          settings: {
            slidesToShow:1,
            slidesToScroll: 1,
          
          },
        },
      ],
});
  
   
			$('.minus').click(function () {
				var $input = $(this).parent().find('input');
				var count = parseInt($input.val()) - 1;
				count = count < 1 ? 1 : count;
				$input.val(count);
				$input.change();
				return false;
			});
			$('.plus').click(function () {
				var $input = $(this).parent().find('input');
				$input.val(parseInt($input.val()) + 1);
				$input.change();
				return false;
			});
	
    

    
    /***Accordin ***/
    
     $(".set > a").on("click", function() {
        if ($(this).hasClass("active")) {
          $(this).removeClass("active");
          $(this)
            .siblings(".content")
            .slideUp(200);
          $(".set > a i")
            .removeClass("fa-angle-up")
            .addClass("fa-angle-down");
        } else {
          $(".set > a i")
            .removeClass("fa-angle-up")
            .addClass("fa-angle-down");
          $(this)
            .find("i")
            .removeClass("fa-angle-up")
            .addClass("fa-angle-down");
          $(".set > a").removeClass("active");
          $(this).addClass("active");
          $(".content").slideUp(200);
          $(this)
            .siblings(".content")
            .slideDown(200);
        }
    });
    
});

